export const isStringEmpty = (value?: string): boolean => value === '' || value === undefined;
